export const STYLING_KEY_BLOCK = 'block';
export const STYLING_KEY_BODY = 'body';
export const STYLING_KEY_BUTTON = 'button';
export const STYLING_KEY_LABEL = 'label';
export const STYLING_KEY_OPTION_TEXT = 'optionText';
export const STYLING_KEY_PAGE = 'page';
export const STYLING_KEY_QUESTION_TEXT = 'questionText';
export const STYLING_KEY_STATIC_TEXT = 'staticText';
export const STYLING_KEY_TEXTFIELD = 'textfield';
